import {
    mapActions,
    mapGetters
  } from 'vuex'
  
  export default {
    data () {
      const columns = [
        {
          prop: 'type.name',
          scopeType: 'type'
        //   icon: 'touxiang1'
        },
        {
          prop: 'title',
          scopeType: 'link'
        },
        {
          prop: 'letterNo',
          label: '编号：',
          scopeType: 'letterNo'
        },
        {
          prop: 'ip',
          scopeType: 'ip'
        },
        {
          prop: 'createTime',
          label: '来信时间：',
          scopeType: 'time'
          // icon: 'shijian',
          // iconLeft: '35px'
        }
      ]
      
      const comments = [
        {
          prop: 'content',
          label: '内容：',
          showComment: 'content'
        },
        {
          prop: 'replyContent',
          label: '回复：',
          showComment: 'replyContent',
          reply: true,
          replyUesr: 'replyUser.username',
          replyTime: 'replyTime'
        }
      ]
      return {
        headers: {
          title: '操作说明',
          showAlertIcon: true,
          content: '操作说明'
        },
        list: {
          api: 'fetchMailboxLetterPage',
          loading: true,
          showComment: false,
          showTitle: false,
          columns,
          statusList: [],
          comments,
          commentsNum: [],
          footButtons: [],
        //   title: 'content.channel.name',
        //   titleText: 'content.title',
          data: [],
          showCheckAll: 'head',
          params: {
            status: 0,
            typeId: null,
            boxId: null,
            letterNo: '',
            title: '',
            createTime: [],
          },
          ids: []
        },
        searchHeader: {
          searchItems: [
            {
              type: 'select',
              value: 'typeId',
              placeholder: '请选择信件类型',
              label: '信件类型：',
              style: {
                width: '120px'
              },
              options: []
            },
            {
              type: 'select',
              value: 'boxId',
              placeholder: '请选择',
              label: '受理信箱：',
              style: {
                width: '120px'
              },
              options: []
            },
            {
              type: 'dataPicker',
              value: 'createTime',
              label: '来信时间：',
            //   hiddenKey: 'senior',
            //   hiddenValue: true,
              startText: '开始日期',
              endText: '结束日期'
            },
            {
              type: 'input',
              label: '信件编号：',
              value: 'letterNo',
              placeholder: '请输入信件编号',
              // hiddenKey: 'senior',
              // hiddenValue: false
            },
            {
              type: 'searchInput',
              label: '信件标题',
              value: 'title',
              placeholder: '请输入信件标题',
            },
          ]
        },
        causeForm: {
        },
        causeRules: {
          replytText: [this.$rules.required()]
        },
        causeFormItems: [
          {
            prop: 'replytText',
            type: 'textarea',
            autosize: { minRows: 3 },
            maxlength: 150
          }
        ],
        causeButtons: [
          {
            text: '确定',
            type: 'Submit'
          }
        ],
        rowId: '',
        reportNum: null
      }
    },
    computed: {
      ...mapGetters(['siteExtendConfig']),
      commentAudit () {
        return this.siteExtendConfig && this.siteExtendConfig.cfg ? this.siteExtendConfig.cfg.commentAudit : '0'
      },
      header () {
        return {
          showAlertIcon: false,
          buttons: [
            // {
            //   type: 'All',
            //   btn: 'Pass',
            //   text: '转发',
            //   icon: 'zhuanfa',
            //   isHidden: this.commentAudit !== '1',
            //   disabled: !this._checkPermission('/usercomment/status', 'PUT')
            // },
            {
              type: 'All',
              btn: 'Delete',
              text: '删除',
              icon: 'delete',
              disabled: !this._checkPermission('/usercomment', 'DELETE')
            }
          ]
        }
      },
      footButtons () {
        const that = this
        return [
          {
            type: 'Reply',
            icon: 'huifu1',
            text: '回复',
            // hiddenKey: 'reply',
            // hiddenValue: false,
            disabled: !this._checkPermission('/letter/reply', 'PUT')
          },
          // {
          //   type: 'PutReply',
          //   icon: 'xiugaihuifu',
          //   text: '修改回复',
          //   // hiddenKey: 'reply',
          //   // hiddenValue: true,
          //   disabled: !this._checkPermission('/letter/reply', 'PUT')
          // },
          // {
          //   type: 'Pass',
          //   icon: 'shenghetongguo',
          //   text: '办结',
          //   // 0-待审核 1-审核通过 2-审核未通过
          //   // hiddenFunc (item) {
          //   //   return item.status === 0 || item.status === 2
          //   // },
          //   disabled: !this._checkPermission('/letter/finish', 'PUT')
          // },
          {
            type: 'Delete',
            icon: 'delete',
            text: '删除信件',
            disabled: !this._checkPermission('/letter', 'DELETE')
          }
        ]
      }
    },
    methods: {
      ...mapActions('config', ['FetchSiteExtentConfig']),
      // 分类列表信息
      fetchLetterTypeList () {
        this.$request.fetchLetterTypeList().then(res => {
          if (res.code === 200) {
            this.searchHeader.searchItems.find(d => d.value === 'typeId').options = res.data.map(d => {
              d.label = d.name
              d.value = d.id
              return d
            })
          }
        })
      },
      // 我的信箱列表信箱
      fetchOwnerLetterBoxList () {
        this.$request.fetchOwnerLetterBoxList().then(res => {
          if (res.code === 200) {
            this.searchHeader.searchItems.find(d => d.value === 'boxId').options = res.data.map(d => {
              d.label = d.name
              d.value = d.id
              return d
            })
          }
        })
      }
    },
    mounted () {
      this.FetchSiteExtentConfig()
      this.fetchLetterTypeList()
      this.fetchOwnerLetterBoxList()
    }
  }
  